import { createSlice } from "@reduxjs/toolkit";
import {
  getCurrency,
  getTimeZone,
  getGallery,
  addOrUpdateService,
  otherServiceImages,
} from "../thunks/serviceRegThunk";
import { handleRegistrationStatus } from "../../utils/registrationHelper";

const initialState = {
  isServiceLoading: false,
  serviceErr: null,
  currencies: [],
  timezones: [],
  galleries: [],
  otherImgs: [],
};

const serviceRegSlice = createSlice({
  name: "setService",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCurrency.pending, (state) => {
        state.isServiceLoading = true;
      })
      .addCase(getCurrency.fulfilled, (state, action) => {
        state.isServiceLoading = false;
        state.currencies = action.payload.data; // ✅ assign to currencies
      })

      .addCase(getCurrency.rejected, (state, action) => {
        state.isServiceLoading = false;
        state.error = action.payload;
      })

      .addCase(getTimeZone.pending, (state) => {
        state.isServiceLoading = true;
      })
      .addCase(getTimeZone.fulfilled, (state, action) => {
        state.isServiceLoading = false;
        state.timezones = action.payload.data;
      })

      .addCase(getTimeZone.rejected, (state, action) => {
        state.isServiceLoading = false;
        state.error = action.payload;
      })
      .addCase(getGallery.pending, (state) => {
        state.isServiceLoading = true;
      })
      .addCase(getGallery.fulfilled, (state, action) => {
        state.isServiceLoading = false;
        state.galleries = action.payload.data;
      })

      .addCase(getGallery.rejected, (state, action) => {
        state.isServiceLoading = false;
        state.error = action.payload;
      })
      .addCase(addOrUpdateService.pending, (state) => {
        state.isServiceLoading = true;
      })
      .addCase(addOrUpdateService.fulfilled, (state, action) => {
        state.isServiceLoading = false;
        state.action = action.payload.data;
        handleRegistrationStatus(action.payload);
      })

      .addCase(addOrUpdateService.rejected, (state, action) => {
        state.isServiceLoading = false;
        state.error = action.payload;
      })
      .addCase(otherServiceImages.pending, (state) => {
        state.isServiceLoading = true;
      })
      .addCase(otherServiceImages.fulfilled, (state, action) => {
        state.isServiceLoading = false;
        state.otherImgs = action.payload.data;
      })

      .addCase(otherServiceImages.rejected, (state, action) => {
        state.isServiceLoading = false;
        state.error = action.payload;
      });
  },
});

export default serviceRegSlice.reducer;
